module.exports = __webpack_public_path__ + "img/Humidity.cf18e2e6.png";